import { AssignmentTurnedIn, Description, PendingActions, Search } from '@mui/icons-material'
import { Autocomplete, Box, Button, Chip, Grid, InputAdornment, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { orderStatusColors } from '../../../Component/OrderStatusColors/orderStatusColors'
import dayjs from 'dayjs'
import { paymentStatusColor } from '../../../Component/PaymentStatusColor/paymnetStatusColor'
import { ApiCreatePayment, ApiGetInvoices } from '../../../Core/Apicall'
import { toast } from 'react-toastify'
import { InvoiceInterface } from '../../../types/Invoice'
import { useSelector } from 'react-redux'
import { RootState } from '../../../Redux/store'

function InvoiceList() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [total, setTotal] = useState<number>(-1)
    const [serchItem, setSearchItem] = useState<string>('')
    const [debouncedSearch, setDebouncedSearch] = useState<string>('');
    const [selecetdPaymentStatus, setSelecetdPaymentStatus] = useState<string>()
    const [selecetdOrderStatus, setSelecetdOrderStatus] = useState<string>()
    const [invoices, setInvoices] = useState<InvoiceInterface[]>()
    const { userDetails } = useSelector((state: RootState) => state.global)
    const [countData, setCountData] = useState<any>()


    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(serchItem);
        }, 500);

        return () => clearTimeout(timer);
    }, [serchItem]);


    const paymentStatus = [
        {
            label: "Pending",
            value: 'PENDING'
        },
        {
            label: "Paid",
            value: 'PAID'
        },
    ]

    const orderStatus = [
        {
            label: "Approved",
            value: 'APPROVED'
        },
        {
            label: "Processing",
            value: 'PROCESSING'
        },
        {
            label: "Completed",
            value: 'COMPLETED'
        },
        {
            label: "Rejected",
            value: 'REJECTED'
        }
    ]

    const getInvoices = async () => {
        try {
            const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}${debouncedSearch ? `&searchTerm=${debouncedSearch}` : ""}${selecetdOrderStatus ? `&orderStatus=${selecetdOrderStatus}` : ""}${selecetdPaymentStatus ? `&paymentStatus=${selecetdPaymentStatus}` : ""}`
            const res = await ApiGetInvoices(data)
            if (res?.status || res?.success) {
                setInvoices(res?.data)
                setTotal(res?.total)
                setCountData(res?.counts)

            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    useEffect(() => {
        getInvoices()
    }, [selecetdOrderStatus, debouncedSearch, selecetdPaymentStatus, page])


    const handlePayment = async (invoiceId: number) => {
        try {
            const data = {
                "invoiceId": invoiceId
            }
            const response = await ApiCreatePayment(data);

            const paymentData = response.data;

            const options = {
                key: paymentData.key,

                amount: paymentData.amount,

                currency: paymentData.currency,

                name: "Wholesale Pro",

                description: `Payment for ${paymentData.invoiceNumber}`,

                order_id: paymentData.razorpayOrderId,

                handler: async function (paymentResponse: any) {
                    console.log("Razorpay success:", paymentResponse);

                    // Send these details to backend for verification
                    toast.success("Payment submitted successfully");
                    getInvoices()
                },

                prefill: {
                    name: userDetails?.firstName,
                    email: userDetails?.email,
                },

                theme: {
                    color: "#47AAA7",
                },

                modal: {
                    ondismiss: function () {
                        console.log("Payment popup closed");
                    },
                },
            };

            const razorpay = new window.Razorpay(options);

            razorpay.on("payment.failed", function (response: any) {
                console.error("Payment failed:", response.error);
            });

            razorpay.open();

        } catch (error) {
            console.error(error);
            toast.error("Unable to initiate payment");
        } finally {
        }
    };

    return (
        <Box className='p-lg-3 p-xl-4 p-2'>
            <Grid container spacing={1} className='my-2 mb-3'>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Total Invoices</Typography>
                            <Typography variant='h5'>{countData?.totalInvoices}</Typography>
                            {/* <Typography variant='caption'> {(0) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(12) >= 0 ? 'text-main' : 'text-danger'}>12.15%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PROCESSING'].bg} !important` }}>
                                <Description sx={{ fontSize: '32px', color: `${orderStatusColors['PROCESSING'].color} !important`, }} />
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Pending Invoices</Typography>
                            <Typography variant='h5'>{countData?.pendingInvoices}</Typography>
                            {/* <Typography variant='caption'> {(8.3) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(8.3) >= 0 ? 'text-main' : 'text-danger'}>{8.3}%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['PENDING'].bg} !important` }}>
                                <PendingActions sx={{ fontSize: '32px', color: `${orderStatusColors['PENDING'].color} !important`, }} />
                                {/* {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })} */}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 6, md: 4, lg: "grow" }} className='border-main card-bg  border-10 p-3'>
                    <Grid container>
                        <Grid size='grow'>
                            <Typography variant='body2'>Paid Invoices</Typography>
                            <Typography variant='h5'>{countData?.paidInvoices}</Typography>
                            {/* <Typography variant='caption'> {(456) >= 0 ? <ArrowUpward className='text-main' sx={{ fontSize: '16px' }} /> : <ArrowDownward className='text-danger' sx={{ fontSize: '16px' }} />}<span className={(456) >= 0 ? 'text-main' : 'text-danger'}>{456}%</span>  from last month</Typography> */}
                        </Grid>
                        <Grid size='auto'>
                            <Box className='p-2 border-10' sx={{ bgcolor: `${orderStatusColors['COMPLETED'].bg} !important` }}>
                                <AssignmentTurnedIn sx={{ fontSize: '32px', color: `${orderStatusColors['COMPLETED'].color} !important`, }} />
                                {/* {AiOutlineProduct({ size: 32, color: 'var(--primary-color)' })} */}
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Box>
                <Box className='bg-white border-10'>
                    <Box className='d-flex align-items-center justify-content-between text-field  gap-2 p-3'>
                        <TextField
                            className='m-0 p-0'
                            value={serchItem}
                            placeholder='Search by orderId,dealer...'
                            sx={{ minWidth: { xs: "100%", md: '300px' } }}
                            onChange={(e) => { setSearchItem(e.target.value) }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start" className='me-0'>
                                            <Search fontSize="small" className='m-0 p-0' />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                        />
                        <Box className='d-none d-md-flex align-items-center gap-2 form-text-field'>
                            <Box sx={{ width: '220px' }}>
                                <Autocomplete
                                    fullWidth
                                    options={paymentStatus}
                                    getOptionLabel={(option) => option.label}
                                    value={paymentStatus.find(option => option.value === selecetdPaymentStatus) || null}
                                    onChange={(_, option) => {
                                        setSelecetdPaymentStatus(option?.value)
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Payment Status..."
                                        />
                                    )}
                                />
                            </Box>
                            <Box sx={{ width: '220px' }}>
                                <Autocomplete
                                    fullWidth
                                    options={orderStatus}
                                    getOptionLabel={(option) => option.label}
                                    value={orderStatus.find(option => option.value === selecetdOrderStatus) || null}
                                    onChange={(_, option) => {
                                        setSelecetdOrderStatus(option?.value || "")
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Order Status..."
                                        />
                                    )}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <TableContainer
                        sx={{
                            border: "1px solid #E5E7EB",
                            borderRadius: "10px",
                            // overflow: "hidden",
                        }}
                    >
                        <Table sx={{ tableLayout: "fixed" }}>
                            <TableHead>
                                <TableRow
                                    sx={{
                                        bgcolor: "var(--primary-light-color)",

                                        "& th": {
                                            fontWeight: 600,
                                            color: "#555",
                                            py: 2,
                                            borderBottom: "1px solid #E5E7EB",
                                        },
                                    }}
                                >
                                    <TableCell sx={{ width: 150 }}>
                                        <Typography variant="caption">Invoice Number</Typography>
                                    </TableCell>

                                    {userDetails?.role === 'client' && (<TableCell sx={{ width: 150 }}>
                                        <Typography variant="caption">Dealer</Typography>
                                    </TableCell>)}

                                    <TableCell sx={{ width: 120 }}>
                                        <Typography variant="caption">Order No.</Typography>
                                    </TableCell>

                                    <TableCell sx={{ width: 180 }} className='text-center'>
                                        <Typography variant="caption">Order Date/Time</Typography>
                                    </TableCell>
                                    <TableCell sx={{ width: 150 }} className='text-center'>
                                        <Typography variant="caption">Amount</Typography>
                                    </TableCell>

                                    <TableCell sx={{ width: 180 }} className='text-center'>
                                        <Typography variant="caption">Payment Status</Typography>
                                    </TableCell>

                                    <TableCell sx={{ width: 180 }} className='text-center'>
                                        <Typography variant="caption" className='text-center'>Order Status</Typography>
                                    </TableCell>

                                    <TableCell sx={{ width: 150 }} className='text-center'>
                                        <Typography variant="caption" className='text-center'>Actions</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {invoices?.map((item: InvoiceInterface) => (
                                    <TableRow>
                                        <TableCell sx={{ width: 150 }}>
                                            <Typography variant="body2">{item?.invoiceNumber}</Typography>
                                        </TableCell>
                                        {userDetails?.role === 'client' && (<TableCell sx={{ width: 150 }}>
                                            <Typography variant="body2">{item?.order?.subClient?.companyName}</Typography>
                                        </TableCell>)}

                                        <TableCell sx={{ width: 120 }}>
                                            <Typography variant="body2">{item?.order?.orderNumber}</Typography>
                                        </TableCell>

                                        <TableCell sx={{ width: 180 }} className='text-center'>
                                            <Typography variant="body2">{dayjs(item?.created_at).format("DD MMM YYYY")}</Typography>
                                            <Typography variant="body2">{dayjs(item?.created_at).format("HH:mm a")}</Typography>
                                        </TableCell>
                                        <TableCell sx={{ width: 150 }} className='text-center'>
                                            <Typography variant="body2">
                                                {Number(item?.amount)?.toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "INR",
                                                })}
                                            </Typography>
                                        </TableCell>

                                        <TableCell sx={{ width: 180 }} className='text-center'>
                                            <Chip
                                                label={item?.status}
                                                size="small"
                                                sx={{
                                                    backgroundColor: paymentStatusColor[item?.status?.toUpperCase()].bg,
                                                    color: paymentStatusColor[item?.status?.toUpperCase()].color,
                                                    fontWeight: 600,
                                                    borderRadius: "20px",
                                                    minWidth: 95,
                                                }}
                                            />
                                        </TableCell>

                                        <TableCell sx={{ width: 180 }} className='text-center'>
                                            <Chip
                                                label={item?.order?.status}
                                                size="small"
                                                sx={{
                                                    backgroundColor: orderStatusColors[item?.order?.status?.toUpperCase()].bg,
                                                    color: orderStatusColors[item?.order?.status?.toUpperCase()].color,
                                                    fontWeight: 600,
                                                    borderRadius: "20px",
                                                    minWidth: 95,
                                                }}
                                            />
                                            {/* <Typography variant="caption" className='text-center'>{item?.orderStatus}</Typography> */}
                                        </TableCell>

                                        <TableCell sx={{ width: 150 }} className='justify-content-center'>
                                            <Box className='d-flex align-items-center justify-content-center'>
                                                {item?.status == "PAID" ? (
                                                    <Button className='btn-outlined-main px-2 py-1'>View</Button>
                                                ) : (
                                                    <Button className='btn-main px-3 py-1' onClick={() => { handlePayment(item?.invoiceId) }}>Pay Now</Button>
                                                )}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Box className='p-3 d-flex justify-content-end'>
                    {total > rowsPerPage &&
                        <Pagination
                            page={page + 1}
                            count={Math.ceil(total / rowsPerPage)}
                            onChange={(_, value) => setPage(value - 1)}
                            shape="rounded"
                            // color="primary"
                            sx={{
                                "& .MuiPaginationItem-root.Mui-selected": {
                                    backgroundColor: 'var(--primary-color)',
                                    color: 'white'
                                }
                            }}
                            showFirstButton={false}
                            showLastButton={false}
                            siblingCount={1}
                            boundaryCount={1}
                        />}
                </Box>
            </Box>
        </Box>
    )
}

export default InvoiceList
